import React from 'react'
import { connect } from 'react-redux'
import { Box, Button, FormControlLabel, Switch } from '@mui/material'
import classNames from 'classnames'
import update from 'immutability-helper'
import { sendWs, RULE, SHUFFLE } from '../../lib/send'
import { confirmShufflePlayers } from '../../lib/dialog'
import { updateDispTeams } from '../../redux/actions/teams'
import { setEditScores } from '../../redux/actions/score'
import Timer from './Timer'
import Board from './Board'
import Clear from './Clear'
import WinLose from './WinLose'

const Master = ({ className, hidden, rule, updateDispTeams, setEditScores }) => {
  const toggleShowScore = evt => {
    sendWs(RULE, update(rule, {
      showScore: { $set: evt.target.checked }
    }))
  }

  const editScores = () => {
    setEditScores()
    updateDispTeams()
  }

  const shufflePlayers = () => {
    confirmShufflePlayers(() => sendWs(SHUFFLE))
  }

  return (
    <Box className={classNames(className, 'master-subactions', { hidden })}>
      <Box className="content">
        <Timer className="group" />
        {rule.board.active && <Board className="group" />}
        <Clear className="group" />
        <WinLose className="group" />
        <Box component="span" className="group show-score">
          <FormControlLabel
            control={
              <Switch color="primary" className="show-score-switch"
                      checked={rule.showScore}
                      onChange={toggleShowScore} />
            }
            label="スコア表示" sx={{ mr: '0px' }} />
        </Box>
        <Box className="group edit">
          <Button variant="outlined" color="mono"
                  className="edit-score-button"
                  onClick={editScores}>
            スコア編集
          </Button>
          <Button variant="outlined" color="mono"
                  className="shuffle-players-button" sx={{ ml: '5px' }}
                  onClick={shufflePlayers}>
            ランダム配置
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default connect(
  state => ({
    score: state.score,
    board: state.board,
    rule: state.rule
  }),
  dispatch => ({
    updateDispTeams: () => dispatch(updateDispTeams()),
    setEditScores: () => dispatch(setEditScores())
  })
)(Master)
